export const USER_ROLE = 'gvi_user_role';
export const USER_MENUS = 'gvi_user_role_menus';
export function getLocalStorage<T extends null | string | Record<string, unknown>>(key: string): T {
  const value = localStorage.getItem(key);

  if (value === null) return value as T;

  try {
    return JSON.parse(value);
  } catch (error) {
    return value as T;
  }
}

export function setLocalStorage(key: string, value: string | number | Record<string, unknown>) {
  if (typeof value !== 'string') {
    localStorage.setItem(key, JSON.stringify(value));
    return;
  }

  localStorage.setItem(key, value);
}

export function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export function clearLocalStorage() {
  localStorage.clear();
}
